import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { SavedView, SharedView } from '../models/saved-view.model';
import { ArtistGridUrlState } from '../pages/overview/artists/artist-rankings-url.util';

interface ViewsApiResponse {
  status: string;
  data: SavedView[];
}

interface ViewApiResponse {
  status: string;
  data: SavedView;
}

@Injectable({ providedIn: 'root' })
export class ViewsService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/views`;

  list(): Observable<SavedView[]> {
    return this.http
      .get<ViewsApiResponse>(this.baseUrl, { withCredentials: true })
      .pipe(map((res) => res.data));
  }

  getPublic(id: number): Observable<SharedView> {
    return this.http
      .get<{ status: string; data: SharedView }>(`${this.baseUrl}/public/${id}`)
      .pipe(map((res) => res.data));
  }

  create(name: string, config: ArtistGridUrlState): Observable<SavedView> {
    return this.http
      .post<ViewApiResponse>(this.baseUrl, { name, config }, { withCredentials: true })
      .pipe(map((res) => res.data));
  }

  update(id: number, patch: { name?: string; config?: ArtistGridUrlState }): Observable<SavedView> {
    return this.http
      .patch<ViewApiResponse>(`${this.baseUrl}/${id}`, patch, { withCredentials: true })
      .pipe(map((res) => res.data));
  }

  remove(id: number): Observable<void> {
    return this.http
      .delete<{ status: string; data: unknown }>(`${this.baseUrl}/${id}`, { withCredentials: true })
      .pipe(map(() => undefined));
  }
}
